import useSWR, { SWRConfiguration } from 'swr';

import { getCurrentLanguage } from '~/localization';
import { fetchFromOldApi } from '~/services/Http';
import { APIs } from '~/services/Http/internalAPIs';

export const useGetCustomDataSubmission = (
  empId: number,
  swrConfig?: SWRConfiguration,
  disabled?: boolean,
) => {
  const language = getCurrentLanguage();
  return useSWR<{ [key: string]: string | string[] | number[] }>(
    !disabled ? ['customPageSubmission', language, empId] : null,
    ([_key, language, empId]) =>
      fetchFromOldApi(APIs.employee.customData(empId, language)).then((r) =>
        r.json(),
      ),
    { revalidateOnFocus: false, ...swrConfig },
  );
};
